import React, { useEffect, useState } from 'react'
import List from './list'
import { Button } from '@mui/material'
import AddEdit from './addEdit'
import getJournalService from '../../../services/getJournalService'
import getCategoryService from '../../../services/getCategoryService'

const Journal = () => {
    const [isOpen, setIsOpen] = useState(false)
    const [dialogType, setDialogType] = useState(true)
    const [editValue, setEditValue] = useState({})
    const [getdata, setGetData] = useState([]);
    const [filterVal, setFilterVal] = useState({
        search: '',
    })
    const { search } = filterVal

    
    const setAddJournal = () => {
        setIsOpen(true)
        setDialogType('add')
        setEditValue({})
    }



    const fetchData = async () => {
        try {
            const list = await getJournalService.GetAllJournalList(filterVal);
            console.log(list)
            setGetData(list); // Set the data to state
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    useEffect(() => {
        fetchData(); // Call fetchData initially when the component mounts
    }, [search && search.length > 3]);
    return (
        <div className='container' >
            <div className='my-3 d-flex justify-content-between align-items-center'>
                <h3>Publication List</h3>

                <Button variant="outlined" type="button" sx={{ marginLeft: '10px' }} onClick={setAddJournal} >
                    + Add Publication
                </Button>
            </div>
                <AddEdit fetchData={fetchData} editValue={editValue} setEditValue={setEditValue} dialogType={dialogType} isOpen={isOpen} setIsOpen={setIsOpen} />
            <div>
                <List setIsOpen={setIsOpen} setEditValue={setEditValue} setDialogType={setDialogType} getdata={getdata} fetchData={fetchData} filterVal={filterVal} setFilterVal={setFilterVal} />
            </div>
        </div>
    )
}

export default Journal